// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SpecialOffersPage_breadCrumbs__BbcqQ","offersSection":"SpecialOffersPage_offersSection__0ZSU4"};